/**
 * Whether a remembered page is safe to return to after sign-in (19 October 2026). A leaf module, tested in
 * web/test/return-path.test.ts.
 *
 * After sign-in the app navigates to the page the person was on (session.tsx, whereWeWere). That page was read
 * from the address bar, which a link can set. React Router 6 has an open redirect through a backslash in a
 * navigation target (GHSA-wrjc-x8rr-h8h6; fixed only in 7.18): "/\evil.example" is read by browsers as
 * "//evil.example", another site. Version 6 has no fix, so the one dynamic target the app navigates to is held
 * to a same-site path here: it starts with a single "/", contains no backslash, no control character and no
 * scheme, and is never protocol-relative.
 */
export function safeReturnPath(to: string | null | undefined): string | null {
  if (!to) return null;
  if (!to.startsWith('/') || to.startsWith('//')) return null;
  if (to.includes('\\') || /[\u0000-\u001f\u007f]/.test(to)) return null;
  if (/^\/[a-z][a-z0-9+.-]*:/i.test(to)) return null;
  return to;
}
